import React from 'react';
import { useData, useField } from '../EpcrDataContext';
import { Icons } from '../EpcrIcons';
import { TextField, OptionField, AutoField, DateTimeField, Section, ViewLayout } from '../EpcrFields';

export function EpcrViewIncident() {
  const sections = [
    { id: "response",    label: "Response" },
    { id: "scene",       label: "Scene" },
    { id: "personnel",   label: "Personnel" },
    { id: "disposition", label: "Disposition" },
    { id: "destination", label: "Destination" },
    { id: "times",       label: "Times" },
    { id: "mileage",     label: "Mileage" },
    { id: "additional",  label: "Additional Factors" },
  ];

  return (
    <ViewLayout sections={sections}>

      <Section id="response" num="01" title="Response" meta="eResponse.* · eDispatch.*">
        <div className="fgrid">

          {/* Row: Incident Number + CAD Import action */}
          <div className="fcol-10">
            <TextField label="Incident Number" elem="eResponse.03" />
          </div>
          <div className="fcol-2" style={{ display: "flex", alignItems: "flex-end" }}>
            <button className="btn-secondary" style={{ width: "100%", justifyContent: "center" }}>
              <Icons.swap size={14} /> CAD Import
            </button>
          </div>

          <div className="fcol-12">
            <TextField label="EMS Response Number" elem="eResponse.04" />
          </div>
          <div className="fcol-12">
            <OptionField label="Type of Service Requested" elem="eResponse.05"
              featured={["2205001", "2205009"]} />
          </div>
          <div className="fcol-12">
            <OptionField label="Response Mode to Scene" elem="eResponse.23"
              featured={["2223001", "2223003", "2223005"]} />
          </div>
          <div className="fcol-12">
            <OptionField label="Additional Response Mode Descriptors" elem="eResponse.24" />
          </div>
          <div className="fcol-12">
            <TextField label="Vehicle Dispatch Location" elem="eResponse.16" />
          </div>
          <div className="fcol-12">
            <TextField label="EMS Vehicle (Unit) Number" elem="eResponse.13" />
          </div>
          <div className="fcol-12">
            <OptionField label="Unit Transport and Equipment Capability" elem="eResponse.07" />
          </div>
          <div className="fcol-12">
            <TextField label="EMS Unit Call Sign" elem="eResponse.14" />
          </div>
          <div className="fcol-12">
            <OptionField label="Dispatch Reason" elem="eDispatch.01"
              featured={["2301013", "2301061", "2301069"]} />
          </div>
          <div className="fcol-12">
            <OptionField label="Dispatch Priority (Patient Acuity)" elem="eDispatch.05" />
          </div>

        </div>
      </Section>

      <Section id="scene" num="02" title="Scene" meta="eScene.*">
        <div className="fgrid">
          <div className="fcol-12">
            <OptionField label="Incident Location Type" elem="eScene.09" />
          </div>
          <div className="fcol-12">
            <TextField label="Incident Facility or Location Name" elem="eScene.13" />
          </div>
          <div className="fcol-12">
            <TextField label="Incident Street Address" elem="eScene.15" />
          </div>
          <div className="fcol-12">
            <TextField label="Scene GPS Location" elem="eScene.11" />
          </div>
          <div className="fcol-12">
            <TextField label="Incident City" elem="eScene.17" />
          </div>
          <div className="fcol-12">
            <TextField label="Incident State" elem="eScene.18" />
          </div>
          <div className="fcol-12">
            <TextField label="Incident ZIP Code" elem="eScene.19" />
          </div>
          <div className="fcol-12">
            <TextField label="Incident County" elem="eScene.21" />
          </div>
          <div className="fcol-12">
            <TextField label="Incident Country" elem="eScene.22" />
          </div>
        </div>
      </Section>

      <Section id="personnel" num="03" title="Personnel" meta="eCrew.* · 2 members">
        <CrewList />
      </Section>

      <Section id="disposition" num="04" title="Disposition" meta="eDisposition.*">
        <div className="fgrid">
          <div className="fcol-12">
            <OptionField label="Unit Disposition" elem="eDisposition.27" />
          </div>
          <div className="fcol-12">
            <OptionField label="Patient Evaluation/Care" elem="eDisposition.28" />
          </div>
          <div className="fcol-12">
            <OptionField label="Crew Disposition" elem="eDisposition.29" />
          </div>
          <div className="fcol-12">
            <OptionField label="Transport Disposition" elem="eDisposition.30" />
          </div>
        </div>
      </Section>

      <Section id="destination" num="05" title="Destination" meta="eDisposition.Destination*">
        <div className="fgrid">
          <div className="fcol-12">
            <TextField label="Destination Name" elem="eDisposition.01" />
          </div>
          <div className="fcol-12">
            <TextField label="Destination Code" elem="eDisposition.02" />
          </div>
          <div className="fcol-12">
            <TextField label="Destination Address" elem="eDisposition.03" />
          </div>
          <div className="fcol-12">
            <TextField label="Destination ZIP" elem="eDisposition.07" />
          </div>
          <div className="fcol-12">
            <OptionField label="Type of Destination" elem="eDisposition.21" />
          </div>
          <div className="fcol-12">
            <AutoField label="Reason for Destination Choice" elem="eDisposition.20" />
          </div>
        </div>
      </Section>

      <Section id="times" num="06" title="Times" meta="eTimes.* · eResponse.08–12">
        <div className="fgrid">
          {/* Time stamps — 3 per row per existing layout */}
          <div className="fcol-4"><DateTimeField label="PSAP Call" elem="eTimes.01" /></div>
          <div className="fcol-4"><DateTimeField label="Dispatch Notified" elem="eTimes.02" /></div>
          <div className="fcol-4"><DateTimeField label="Unit Notified by Dispatch" elem="eTimes.03" /></div>
          <div className="fcol-4"><DateTimeField label="Unit En Route" elem="eTimes.05" /></div>
          <div className="fcol-4"><DateTimeField label="Unit Arrived on Scene" elem="eTimes.06" /></div>
          <div className="fcol-4"><DateTimeField label="Arrived at Patient" elem="eTimes.07" /></div>
          <div className="fcol-4"><DateTimeField label="Unit Left Scene" elem="eTimes.09" /></div>
          <div className="fcol-4"><DateTimeField label="Patient Arrived at Destination" elem="eTimes.11" /></div>
          <div className="fcol-4"><DateTimeField label="Unit Back in Service" elem="eTimes.13" /></div>

          {/* Delay fields */}
          <div className="fcol-12">
            <AutoField label="Dispatch Delays" elem="eResponse.08"
              shortcuts={[{ label: "None/No Delay", value: "2208013" }]} />
          </div>
          <div className="fcol-12">
            <AutoField label="Response Delays" elem="eResponse.09"
              shortcuts={[{ label: "None/No Delay", value: "2209011" }]} />
          </div>
          <div className="fcol-12">
            <AutoField label="Scene Delays" elem="eResponse.10"
              shortcuts={[{ label: "None/No Delay", value: "2210017" }]} />
          </div>
          <div className="fcol-12">
            <AutoField label="Transport Delays" elem="eResponse.11"
              shortcuts={[{ label: "None/No Delay", value: "2211011" }]} />
          </div>
          <div className="fcol-12">
            <AutoField label="Turn-Around Delays" elem="eResponse.12"
              shortcuts={[{ label: "None/No Delay", value: "2212015" }]} />
          </div>
        </div>
      </Section>

      <Section id="mileage" num="07" title="Mileage" meta="eResponse.19–22">
        <div className="fgrid">
          <div className="fcol-3"><TextField label="Begin Odometer" elem="eResponse.19" /></div>
          <div className="fcol-3"><TextField label="On Scene Odometer" elem="eResponse.20" /></div>
          <div className="fcol-3"><TextField label="At Destination Odometer" elem="eResponse.21" /></div>
          <div className="fcol-3"><TextField label="End Odometer" elem="eResponse.22" /></div>
          <div className="fcol-12">
            <MileageSummary />
          </div>
        </div>
      </Section>

      <Section id="additional" num="08" title="Additional Factors" meta="eScene.* · custom">
        <div className="fgrid">
          <div className="fcol-12">
            <TextField label="Other EMS or Public Safety Agencies at Scene" elem="eScene.02" />
          </div>
          <div className="fcol-12">
            <OptionField label="First Agency to Provide Patient Care" elem="eScene.24"
              inline={false} />
          </div>
          <div className="fcol-12">
            <OptionField label="Additional Responders" elem="eScene.04"
              shortcuts={[{ label: "None", clear: true }]} />
          </div>
          <div className="fcol-12">
            <TextField label="Additional Comments" path="custom/AdditionalComments" multiline rows={3} />
          </div>
        </div>
      </Section>

    </ViewLayout>
  );
}

function CrewList() {
  const data = useData();
  const crew = useField("eCrew/eCrew.CrewGroup") || [];
  const list = Array.isArray(crew) ? crew : [];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {list.map((c, i) => {
        const id = c["eCrew.01"] || "";
        const initials = id.slice(0, 2).toUpperCase();
        const roles = Array.isArray(c["eCrew.03"]) ? c["eCrew.03"] : (c["eCrew.03"] ? [c["eCrew.03"]] : []);
        return (
          <div key={i} style={{
            display: "grid",
            gridTemplateColumns: "40px 1fr 220px 1fr auto",
            alignItems: "center",
            gap: 16,
            border: "1px solid var(--epcr-line)",
            borderRadius: 6,
            padding: "12px 14px",
            background: "#fff",
          }}>
            <div style={{
              width: 36, height: 36, borderRadius: 18,
              background: "var(--epcr-bg-2)",
              color: "var(--epcr-ink-3)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontWeight: 600, fontSize: 12, fontFamily: "'IBM Plex Mono', monospace",
            }}>{initials || "—"}</div>
            <div>
              <div style={{ fontSize: 10, color: "var(--epcr-ink-4)", letterSpacing: "0.08em", textTransform: "uppercase" }}>Crew Member ID</div>
              <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 13.5, fontWeight: 500 }}>{id || "—"}</div>
            </div>
            <div>
              <div style={{ fontSize: 10, color: "var(--epcr-ink-4)", letterSpacing: "0.08em", textTransform: "uppercase" }}>Level (eCrew.02)</div>
              <div style={{ fontSize: 13 }}>{data.label("eCrew.02", c["eCrew.02"]) || "—"}</div>
            </div>
            <div>
              <div style={{ fontSize: 10, color: "var(--epcr-ink-4)", letterSpacing: "0.08em", textTransform: "uppercase" }}>Response Roles (eCrew.03)</div>
              <div style={{ fontSize: 13, display: "flex", flexWrap: "wrap", gap: 4, marginTop: 2 }}>
                {roles.length ? roles.map(r => (
                  <span key={r} className="chip" style={{ background: "var(--epcr-bg-1)" }}>{data.label("eCrew.03", r) || r}</span>
                )) : <span style={{ color: "var(--epcr-ink-4)" }}>—</span>}
              </div>
            </div>
            <button className="icon-btn"><Icons.more size={16} /></button>
          </div>
        );
      })}
      {list.length === 0 && (
        <div style={{ padding: 24, textAlign: "center", color: "var(--epcr-ink-4)", border: "1px dashed var(--epcr-line)", borderRadius: 6 }}>
          No crew members recorded
        </div>
      )}
      <button className="btn-secondary" style={{ alignSelf: "flex-start", marginTop: 4 }}>
        <Icons.plus size={14} /> Add crew member
      </button>
    </div>
  );
}

function MileageSummary() {
  const begin   = parseFloat(useField("eResponse/eResponse.19"));
  const onScene = parseFloat(useField("eResponse/eResponse.20"));
  const atDest  = parseFloat(useField("eResponse/eResponse.21"));
  const end     = parseFloat(useField("eResponse/eResponse.22"));
  const total    = isFinite(end) && isFinite(begin) ? (end - begin).toFixed(1) : null;
  const loaded   = isFinite(atDest) && isFinite(onScene) ? (atDest - onScene).toFixed(1) : null;
  const deadhead = total != null && loaded != null ? (parseFloat(total) - parseFloat(loaded)).toFixed(1) : null;
  return (
    <div style={{ background: "var(--epcr-bg-1)", border: "1px solid var(--epcr-line)", borderRadius: 6, padding: "14px 16px", display: "flex", gap: 32, fontFamily: "'IBM Plex Mono', monospace", fontSize: 13 }}>
      <div><span style={{ color: "var(--epcr-ink-4)" }}>Loaded miles</span> &nbsp; <strong>{loaded ?? "—"}</strong></div>
      <div><span style={{ color: "var(--epcr-ink-4)" }}>Total miles</span> &nbsp; <strong>{total ?? "—"}</strong></div>
      <div><span style={{ color: "var(--epcr-ink-4)" }}>Deadhead</span> &nbsp; <strong>{deadhead ?? "—"}</strong></div>
    </div>
  );
}
